<template>
  <el-dialog
          :title="!dataForm.id ? '新增' : '修改'"
          :close-on-click-modal="false"
          :visible.sync="visible">
    <el-form :model="dataForm" ref="dataForm" :rules="rules" @keyup.enter.native="dataFormSubmit()"
             label-width="160px">
      <el-form-item label="上级部门" v-if="parentDepart.id">
        <span>{{parentDepart.deptName}}</span>
      </el-form-item>
      <el-form-item label="部门名称" prop="deptName">
        <el-input v-model="dataForm.deptName" placeholder="部门名称"></el-input>
      </el-form-item>
      <el-form-item label="部门编号" prop="deptCode">
        <el-input v-model="dataForm.deptCode" placeholder="部门编号"></el-input>
      </el-form-item>
      <el-form-item label="部门类型" prop="deptType">
         <el-select v-model="dataForm.deptType" @change="dataForm.deptLegalCode=''" placeholder="请选择">
            <el-option
              v-for="item in typeOptions"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="社会统一信用码" prop="deptLegalCode" v-if="dataForm.deptType==1">
        <el-input v-model="dataForm.deptLegalCode" placeholder="社会统一信用码"></el-input>
      </el-form-item>
      <el-form-item label="部门序号" prop="sort">
        <el-input v-model="dataForm.sort" placeholder="名称"></el-input>
      </el-form-item>
      <el-form-item label="部门简介" prop="description">
        <el-input type="textarea" v-model="dataForm.description" placeholder="部门简介"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {validatorCode} from '@/utils/validate.js'
  export default {
    props: ['mainContentViewHeight'],
    data() {
      return {
        visible: false,
        dataForm: {
          id: '',
          orgId: '',
          parentId: '0',
          sort: 10,
          deptType: 4,
          deptCode: '',
          deptName: '',
          description: '',
        },
        rules:{
          deptLegalCode: [
            {required: true, trigger: 'blur',validator:validatorCode},
          ]
        },
        typeOptions:[],
        parentDepart:{}
      }
    },
    methods: {
      init(orgId,parentDepart,id) {
        this.getTypeData();
        this.dataForm.orgId=orgId
        if(parentDepart===undefined){
          parentDepart={id:''}
        }
        this.parentDepart=parentDepart
        this.dataForm.id = id || ''
        this.dataForm.parentId = parentDepart.id
        if(this.dataForm.parentId==''){
          this.dataForm.parentId='0'
        }
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields();
        })
        this.visible = true
        if (this.dataForm.id) {
          this.$http({
            url: '/auth/department/getDepartment?id=' + this.dataForm.id,
            method: 'post'
          }).then(({data}) => {
            if (data && data.code === '1') {
              this.dataForm = data.data
            }else {
              this.dataForm.orgId=orgId
            }
          })
        }
      },
      resetForm() {
        this.$refs['dataForm'].resetFields();
      },
      getTypeData(){
        this.$http({
          url: '/getEnumList/4',
          method: 'post',
          data: {
            required:true
          }
        }).then((res) => {
          this.typeOptions=res.data;
          this.typeOptions.forEach((ele)=>{
            ele.id=Number(ele.id)
          })
        })
        
      },
      // 表单提交
      dataFormSubmit() {
        this.$http({
          url: '/auth/department/saveOrUpdateDepartment',
          method: 'post',
          data: this.dataForm
        }).then(({data}) => {
          if (data && data.code === '1') {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.visible = false
                this.$emit('refreshDataList')
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      }
    },

  }
</script>
<style lang="scss" scoped>
    .el-select{
      width: 100%;
    }
</style>
